var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 30,
    height: 30,
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2105",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2107",
    d: "M290.286 17.306h130.232v130.232H290.286z",
    style: {
      fill: "#f3f7f8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.75748,
      strokeLinecap: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2109",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2111",
    d: "M290.286 17.306h130.232v130.232H290.286z",
    style: {
      fill: "#f3f7f8",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.75748,
      strokeLinecap: "round"
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#e0aa93}.cls-5{fill:#cc5f50}.cls-12{fill:#d1957d}.cls-13{fill:#c2443a}.cls-14{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(-15.723 -5.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g946",
    transform: "translate(-578 -12)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2063",
    d: "M704.268 129.402c.064 4.522-.518 11.51-1.301 18.135h12.256c-2.626-7.908-6.524-16.058-10.955-18.135z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2065",
    d: "M693.994 124.152c-.352-.012-.57.01-.517.1 3.17 5.343 1.228 14.524-1.483 23.285h13.123c.873-8.778 1.185-17.25.28-18.935-.9-1.69-5.749-4.8-8.229-4.3.157.233-2.116-.114-3.174-.15z",
    style: {
      fill: "#f3f7f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2067",
    d: "M674.396 117.842c1 1.67.12 6.82 3.08 8.4 1.41.75 2.471 1.19 2.231 3-.81 6.12-7.45 11-14.77 12.65-2.83.65-6.48 1.11-10.74 1.81-6.273 1.033-14.132 2.335-19.392 3.835h59.482c2.653-8.384 4.645-17.062 1.86-21.785-2.47-4.2-4.87-4.32-8.19-4.48-2.63-.13-9.71-1.18-13.56-3.43z",
    style: {
      fill: "#d6e1e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2069",
    d: "M634.527 62.232c4.87-8.6 13.3-8.42 20.42-6 4.44-2.49 7.83-2.75 13.32-.82 5.76 2 8.38 5.79 10.06 10.27 1.43 3.8 5.59 3 8.45 3.61.14 0-.14-3.65 0-3.61-3.81-27.72-19.45-34.56-31-37.29-8.88-2.1-17.44-.16-22.9 5.2-11.16 11-4.31 26.66-2.06 31 .39-.74 3.12-1.32 3.71-2.36z",
    style: {
      fill: "#ffd835"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2071",
    d: "M684.797 77.522a73.83 73.83 0 0 0 10.1 5.8c1.74-4.65 2.24-7.53-1.3-11.82-2.54-3.08-5.12-3.68-7.62-4.25-2.86-.66-5.81-1.34-7.56-6-1.52-4-5.92-7.84-11.23-9.7-5.31-1.86-10.24-1.47-14.3.94-6.59-2.6-16.88.07-21 7.35a27.67 27.67 0 0 0-1.9 3.93.83.83 0 0 1-.17.45 14.11 14.11 0 0 0-.56 2.25c-.3 1.67-.58 2.66-3.26 5.15-4.5 4.19-1.86 13.57 2.19 17a12.74 12.74 0 0 0 .94 6.49c2.42 5.24 12.12 6.83 15 6.94a51.58 51.58 0 0 1-4.71-10l12.98-26.62c1.79-.23 3.63-3 10.92 5.39a.77.77 0 0 1 .06.11.78.78 0 0 1 .07.1l8.57 15.07 6.2 5.09a15.45 15.45 0 0 1-4.84 3.54 4.14 4.14 0 0 1-2.58.44l-.16 4.67s1.81 10.49 3.32 16.38c1.64.07 7.8-.62 9-1.73a1.37 1.37 0 0 0 .5-1c0-1.26-.78-2.52-1.65-3.85-1.34-2.06-2.85-4.39-1.14-7.09 1.07-1.69 3-2.65 4.88-3.58 2.89-1.44 5.62-2.79 6-6.57.65-6.61.53-10.05-6.81-14.84l.39-.86c.11-.02-.38.79-.33.82z",
    className: "cls-5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2073",
    d: "M655.428 62.316a15.32 15.32 0 0 0-3.1.026h-.111c-.57 0-13.889 1-14.899 11.72 0 0-.301 2.28-.351 4.51v3.66a42.57 42.57 0 0 0 1.54 10.86c2.34 7.49 9.64 16 14.21 16.57l.62 1.77a6.62 6.62 0 0 1-.82 0 6.85 6.85 0 0 1-1.13-.24c.74 2.31 2.31 8.73-1.25 13.25-1.56 2-4.569 2.57-8.389 3.32-6.91 1.36-16.38 3.219-21.49 15.199l-2.873 4.576h32.404c1.893-.326 3.8-.65 5.658-.955 4.22-.7 8.21-1.36 11-2 7-1.61 16.95-11.75 17.6-16.72a1.89 1.89 0 0 0-.9-2.21 14.91 14.91 0 0 1-7.569-9 97.5 97.5 0 0 1-2.38-13.84l.24-6.86 1.1.23a2.63 2.63 0 0 0 2.3-.06c2.09-1.08 3.4-4.87 3.73-6.24.09-.26 1.82-4.24-1.3-7-2.6-2.3-4.25-.55-4.25-.55a3.66 3.66 0 0 0-.82.87l-4.561-10.14a18.47 18.47 0 0 0-8.309-8.95 15.32 15.32 0 0 0-5.9-1.796z",
    className: "cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path2075",
    d: "M650.517 108.912a9 9 0 0 0 7.81-.45c4.41-2.21 9.16-4.5 11.49-8.33 0 0-4.51 8.86-13.06 13.46 0 0-3.49 3.1-4.64 6.31a23.5 23.5 0 0 0-1.6-10.99z",
    className: "cls-12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path2077",
    d: "M628.197 88.692a13.61 13.61 0 0 1 2.09-9.26c3-4.57 4.66-6.06 4.24-9.78a11.73 11.73 0 0 1-5.09 6c-3.83 2.13-4.39 8.53-4.39 8.53a11.37 11.37 0 0 0 3.15 4.51z",
    className: "cls-13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path2079",
    d: "M679.387 69.312s.49 6.51 7.84 10.86c0 0 5.1 3.22 4.58 8.46a11.91 11.91 0 0 0 3.09-5.3 17.4 17.4 0 0 0-7.26-6.42c-5.06-2.54-4.53-.87-8.25-7.6z",
    className: "cls-13"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path2081",
    d: "M676.997 84.182c-.25-.15-2.36 0-2.08 3.42.1 1.16 1.56 1.76.78 2.54s-1.79 1.88-.57 2.41c2.08.88 5.51-6.2 1.87-8.37z",
    className: "cls-12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path2083",
    d: "M650.787 95.642a4.69 4.69 0 0 1-2.38-3 31.4 31.4 0 0 0 1.5-6.42c.4-2.44-.93-5.17-2.26-7.24l-1.92.23c3 3.31 2.14 10.1 1.49 11.87-.65 1.77-1 3.68 1.92 4.82a6.16 6.16 0 0 1 2.62 1.53c-.27-1.9-.97-1.79-.97-1.79z",
    className: "cls-12"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path2085",
    d: "M647.417 78.532s1.06.59.66 1.25-.75.7-1.87.39c-1.12-.31-2.18-1.68-4.66-1.1-2.48.58-3.8 1-3.8 1s3.5-4.36 9.67-1.54z",
    className: "cls-5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path2087",
    d: "M655.107 78.262s-1.1.68-.52 1.35c.58.67 1.24.5 2.39 0 1.15-.5 2-1.72 6-1s5.41 2.24 5.41 2.24a7.51 7.51 0 0 0-5.65-3.52c-3.96-.45-5.1-.19-7.63.93z",
    className: "cls-5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path2089",
    d: "M656.217 83.322a5.63 5.63 0 0 1 4-1.61c2.5 0 5.12 1.52 6.68 1.61a32.94 32.94 0 0 1-6.68 1.3c-3.29.21-4-1.3-4-1.3z",
    className: "cls-14"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path2091",
    d: "M646.587 83.322a7.32 7.32 0 0 0-3.63-1.25c-1.69.07-3.7 1.5-4.81 1.63 0 0 4.18 1.39 6 .94a4 4 0 0 0 2.44-1.32z",
    className: "cls-14"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle2093",
    cx: 660.477,
    cy: 83.172,
    r: 1.36,
    className: "cls-13"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle2095",
    cx: 642.857,
    cy: 83.442,
    r: 1.24,
    className: "cls-13"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path2097",
    d: "M648.167 100.342a24.42 24.42 0 0 1 2.67-1.2 6.18 6.18 0 0 1 1.35.6l1.2-.6a18.75 18.75 0 0 1 4.11 1 78 78 0 0 1-9.33.2z",
    className: "cls-12"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path2099",
    d: "M649.697 102.192a11.47 11.47 0 0 0 6 0 2.36 2.36 0 0 1-2.48 1.77c-2.17.07-3.31.02-3.52-1.77z",
    className: "cls-12"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.39c27bd848211758f4ae5adfec7d4502.svg";
export { ForwardRef as ReactComponent };